import { render, staticRenderFns } from "./MyInstituteEdit.vue?vue&type=template&id=37455387&"
import script from "./MyInstituteEdit.vue?vue&type=script&lang=js&"
export * from "./MyInstituteEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports